<div class="popout">
  <header class="popout__header">
    <mat-icon class="popout__header-icon">{{ icon }}</mat-icon>
    <span class="popout__header-title">{{ title }}</span>
    <button class="popout__close-btn" type="button" (click)="popoutClose.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="popout__search-bar">
    <mat-icon class="popout__search-icon">search</mat-icon>
    <label for="popout-search-input" class="popout__visually-hidden">{{ searchPlaceholder }}</label>
    <input
      id="popout-search-input"
      class="popout__search-input"
      type="text"
      [value]="searchQuery()"
      (input)="onSearch($any($event).target.value)"
      [placeholder]="searchPlaceholder"
    />
    <button
      class="popout__sort-btn"
      type="button"
      [matTooltip]="sortToggleTitle"
      (click)="sortToggle.emit()"
    >
      <mat-icon class="popout__sort-icon">{{ sortToggleIcon }}</mat-icon>
    </button>
  </div>

  <div class="popout__list">
    @for (group of filteredGroups(); track group.key) {
      <div class="popout__group">
        <div
          class="popout__group-header"
          [tabindex]="0"
          (click)="toggleGroup(group.key)"
          (keydown.enter)="toggleGroup(group.key)"
        >
          <span class="popout__group-title">{{ group.key }}</span>
          <mat-icon class="popout__group-chevron">
            {{ isGroupExpanded(group.key) ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </div>
        @if (isGroupExpanded(group.key)) {
          @for (item of group.items; track item.id) {
            <div
              class="popout__item"
              [class.popout__item--active]="item.id === activeItemId"
              [tabindex]="0"
              (click)="itemSelect.emit(item.id)"
              (keydown.enter)="itemSelect.emit(item.id)"
            >
              <span class="dot"></span>
              <span class="popout__item-label">{{ item.label }}</span>
              @if (item.labelIcon) {
                <mat-icon
                  class="popout__item-label-icon"
                  [matTooltip]="item.labelIconTooltip ?? ''"
                >{{ item.labelIcon }}</mat-icon>
              }
              @if (item.showAction) {
                <button
                  class="popout__item-action"
                  type="button"
                  [matTooltip]="item.actionTooltip ?? ''"
                  (click)="$event.stopPropagation(); itemAction.emit(item.id)"
                  (keydown.enter)="$event.stopPropagation(); itemAction.emit(item.id)"
                >
                  <mat-icon>{{ item.actionIcon ?? 'more_horiz' }}</mat-icon>
                </button>
              }
            </div>
          }
        }
      </div>
    }
    @if (filteredGroups().length === 0) {
      <div class="popout__empty">{{ emptyMessage }}</div>
    }
  </div>

  @if (showAdd || showSettings) {
    <div class="popout__footer">
      @if (showSettings) {
        <div
          class="popout__footer-action"
          [tabindex]="0"
          (click)="settings.emit()"
          (keydown.enter)="settings.emit()"
        >
          <mat-icon class="popout__footer-icon">settings</mat-icon>
          <span>{{ settingsLabel }}</span>
        </div>
      }
      @if (showAdd) {
        <div
          class="popout__footer-action"
          [tabindex]="0"
          (click)="add.emit()"
          (keydown.enter)="add.emit()"
        >
          <mat-icon class="popout__footer-icon">add</mat-icon>
          <span>{{ addLabel }}</span>
        </div>
      }
    </div>
  }
</div>
